module.exports = __webpack_public_path__ + "img/category-detail-icon2.34a972e9.svg";